import { capitalizeFirstLetter } from ".";
import { FLOW_AREA, FlowAreaType } from "../constants/flow";
import { IHealthGetCoverage, IHealthFormatCoverage } from "../containers/hirings/new-hiring/health/health- guarantee/health-guarantee-dto/health-guarantee-risks-dto";

export function formatCoveragesHealth(coveragesData: IHealthGetCoverage[], flow: FlowAreaType): IHealthFormatCoverage[] {
  const coveragesObj: IHealthFormatCoverage[] = [];
  coveragesData.sort((a: IHealthGetCoverage, b: IHealthGetCoverage) => {
    if (typeof a.order === "number" && typeof b.order === "number") {
      if (a.order > b.order) return 1;
      if (a.order < b.order) return -1;
      return 0;
    } else return 0;
  });

  coveragesData.forEach((coverage: IHealthGetCoverage) => {
    let desc = "";
    if (coverage.name) desc = capitalizeFirstLetter(coverage.name.toLowerCase());

    let coverageObj: IHealthFormatCoverage = {
      capitales: coverage.capitales,
      capMaxCober: coverage.capMaxCober,
      capMinCober: coverage.capMinCober,
      checked: coverage.checked ? true : false,
      code: coverage.code,
      description: desc,
      edadMax: coverage.edadMax ? coverage.edadMax : "",
      edadMin: coverage.edadMin ? coverage.edadMin : "",
      order: coverage.order,
      required: coverage.required ? coverage.required : false,
    };

    // Agrupación de nuevo tipo de coberturas obligatorias a escoger 1
    if (coverage.coveragesGroup) {
      coverageObj.groupName = coverage.coveragesGroup.groupName;
      coverageObj.groupRequired = coverage.coveragesGroup.required;
      coverageObj.required = false;
    }

    if (flow === FLOW_AREA.CONTRATACION) {
      coverageObj.capital = !!coverage.capitales ? "" : 1;

      if (coverage.capitales) {
        coverageObj.capitalRequired = true;
        coverageObj.errorCode = "";
      }
    }

    coveragesObj.push(coverageObj);
  });

  return coveragesObj;
}
